import { AppContent } from '../AppContent';
import { MetaContentValues } from '../metaContentValues';

const landlordAssociations: AppContent['landlordAssociations'] = {
  metaContent: {
    title: MetaContentValues.landlordAssociations.title,
  },
  backLabel: 'Back to Landlord support',
  title: 'Landlord associations',
  the: 'The ',
  englandAndWales: {
    title: 'England and Wales',
    nationalResidentialLinkLabel: 'National Residential Landlords Association',
    nationalResidentialLinkHref: 'https://www.nrla.org.uk',
    isTheLargest:
      ' (NRLA) is the largest landlord association in the UK with over 100,000 members.',
    britishLandlordsLinkLabel: 'British Landlords Association',
    britishLandlordsLinkHref: 'https://thebla.co.uk/',
    isANational:
      ' (BLA) is a national association for residential and commercial landlords. It has over 47,500 members.',
  },
  scotland: {
    title: 'Scotland',
    scottishAssociationLinkLabel: 'Scottish Association of Landlords',
    scottishAssociationLinkHref: 'https://scottishlandlords.com/',
    offersPracticalHelp:
      ' (SAL) offers practical help to the private letting sector in Scotland.',
  },
  northernIreland: {
    title: 'Northern Ireland',
    landlordsAssocationLinkLabel: 'Landlords Association for Northern Ireland',
    landlordsAssocationLinkHref: 'https://www.lani.org.uk/',
    representsTheInterests:
      ' (LANI) represents the interests of independent private landlords across Northern Ireland.',
    canAlsoCheck:
      "You can also check to see if there's any landlord associations where you live or have your rental property.",
  },
};

export default landlordAssociations;
